import { useState } from 'react';
import { Alert, Box, Button, Container, Stack, TextField, Typography } from '@mui/material';
import apiClient from '../components/ApiClient/ApiClient';

export default function OperationAuditPage() {
  const [from, setFrom] = useState(new Date().toISOString().slice(0, 10));
  const [to, setTo] = useState(new Date().toISOString().slice(0, 10));
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState('需有獨立稽核查閱權限；時間以台灣時間查詢。');
  const [busy, setBusy] = useState(false);

  const query = async (next = false) => {
    setBusy(true);
    try {
      const end = new Date(`${to}T00:00:00+08:00`);
      end.setUTCDate(end.getUTCDate() + 1);
      const response = await apiClient.get('/OperationAudit', { params: {
        from: `${from}T00:00:00+08:00`, to: end.toISOString(), keyword,
        beforeId: next ? rows[rows.length - 1]?.Id : undefined,
      } });
      const data = response.data.data ?? response.data.Data ?? [];
      setRows(data);
      setMessage(data.length ? `本頁 ${data.length} 筆，依紀錄編號由新到舊排列。` : '沒有符合的紀錄。');
    } catch (error) {
      setRows([]);
      setMessage(error.response?.data?.message ?? error.response?.data?.Message ?? '查詢失敗，請確認權限或聯絡管理員。');
    } finally { setBusy(false); }
  };

  const hold = async (row) => {
    const reason = window.prompt(row.IsHeld ? '請填寫解除保留的原因' : '請填寫調查／保留的原因');
    if (!reason?.trim()) return;
    setBusy(true);
    try {
      await apiClient.post('/OperationAudit/Hold', { id: row.Id, held: !row.IsHeld, reason });
      setRows((previous) => previous.map((item) => item.Id === row.Id ? { ...item, IsHeld: !row.IsHeld, HoldReason: reason } : item));
      setMessage('保留設定已更新。');
    } catch (error) {
      setMessage(error.response?.data?.message ?? error.response?.data?.Message ?? '更新失敗，請確認保留設定權限。');
    } finally { setBusy(false); }
  };

  return <Container maxWidth="xl">
    <Typography variant="h4" sx={{ mb: 2 }}>操作稽核紀錄</Typography>
    <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
      <TextField type="date" label="開始日期" value={from} onChange={(e) => setFrom(e.target.value)} InputLabelProps={{ shrink: true }} />
      <TextField type="date" label="結束日期" value={to} onChange={(e) => setTo(e.target.value)} InputLabelProps={{ shrink: true }} />
      <TextField label="單號／批號／帳號／追蹤編號" value={keyword} onChange={(e) => setKeyword(e.target.value)} />
      <Button disabled={busy} onClick={() => query()}>查詢</Button>
      <Button disabled={busy || rows.length !== 100} onClick={() => query(true)}>下一頁</Button>
    </Stack>
    <Alert severity="info">{message}</Alert>
    {rows.map((row) => <Box key={row.Id} sx={{ border: '1px solid #ddd', p: 2, mt: 2 }}>
      <Typography>{row.Id} · {new Date(`${row.OccurredUtc}Z`).toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' })} · {row.CompanyCode} · {row.UserName}（{row.UserId}）</Typography>
      <Typography>{row.Action} · {row.TableName} · {row.RecordKey}</Typography>
      <Typography variant="body2">{row.HttpMethod} {row.RequestPath} · 追蹤編號：{row.TraceId}</Typography>
      <details><summary>修改前後內容</summary>
        <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>修改前：{row.BeforeJson || '無'}{'\n'}修改後：{row.AfterJson || '無'}</Typography>
      </details>
      <Typography variant="body2">{row.IsHeld ? `保留中：${row.HoldReason}` : '依保存期限處理'}</Typography>
      <Button disabled={busy} onClick={() => hold(row)}>{row.IsHeld ? '解除保留' : '設定保留'}</Button>
    </Box>)}
  </Container>;
}
